import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { CreateTimeSpotSlotPage } from './create-time-spot-slot.page';

const routes: Routes = [
  {
    path: '',
    component: CreateTimeSpotSlotPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CreateTimeSpotSlotPage]
})
export class CreateTimeSpotSlotPageModule {}
